import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSession from "vue-session";
import VueMoment from "vue-moment";
import VeeValidate from "vee-validate";
import HighchartsVue from "highcharts-vue";
import JsonExcel from "vue-json-excel";
import Multiselect from "vue-multiselect";
import BootstrapVue from "bootstrap-vue";
import Password from "vue-password-strength-meter";
import vSelect from "vue-select";
import VueCryptojs from 'vue-cryptojs'
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VueCroppie from 'vue-croppie';
import VueToast from 'vue-toast-notification';
import { PhotoCapture, VideoCapture } from "vue-media-recorder";

import './css/toast.css'
import wndata from './js/wn_data.json'
import VueQuillEditor from 'vue-quill-editor'
import cryptoscript  from "./js/cryptoscript";

 
// // require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 
Vue.use(VueQuillEditor)
const config = {
  classes: true,
  events: "blur", //Nag- This makes validations to fire on blur and on submit
  classNames: {
    invalid: "is-invalid"
  }
};
Vue.use(VueToast, {
  type: 'center',
  position : 'top',
  duration: wndata.toastduration,
  wordWrap: true
});
Vue.use(cryptoscript)
Vue.config.devtools = true;
Vue.component("downloadExcel", JsonExcel);
Vue.use(VueMoment);
Vue.use(VueCroppie);
Vue.use(HighchartsVue);
Vue.use(BootstrapVue);
Vue.use(VueCryptojs)
Vue.component("VideoCapture", VideoCapture);
Vue.component("Password", Password);
Vue.component("Multiselect", Multiselect);
Vue.component("v-select", vSelect);

Vue.use(VeeValidate, config);
export const bus = new Vue();
Vue.use(VueSession);
Vue.config.productionTip = false;

new Vue({
  router,
  store,

  render: h => h(App)
}).$mount("#app");
